import { motion } from "framer-motion";

function CertificateCard({ props }) {
  return (
    <motion.article
      className="certificate-bento-card group"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      {props.image && (
        <figure className="certificate-bento-image">
          <img
            src={props.image}
            alt={props.title}
            loading="lazy"
            decoding="async"
            width="900"
            height="600"
            className="w-full h-full object-cover"
            onError={event => { event.currentTarget.style.display = "none"; }}
          />
          {props.logo1 && (
            <div className="certificate-bento-logo">
              <img
                src={props.logo1}
                alt={props.logoName || ""}
                width="20"
                height="20"
                loading="lazy"
                decoding="async"
                className="w-5 h-5 object-contain"
              />
            </div>
          )}
        </figure>
      )}

      <div className="certificate-bento-body">
        <h3 className="certificate-bento-title">{props.title}</h3>
        {props.details && <p className="certificate-bento-copy">{props.details}</p>}
        {props.logoName && (
          <p className="certificate-bento-issuer">{props.logoName}</p>
        )}
      </div>
    </motion.article>
  );
}

export default CertificateCard;
